import { z } from 'zod';

import { PaymentProviders } from 'payments/constants/providers';
import { BENTOBOX_PAYMENT_CREDENTIALS_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { restClient } from 'utility/restClient';
import { defaultWhenNullish } from 'utility/zod';

const CommerceHubCredentialsResponse = z.object({
  commerce_hub_merchant_id: defaultWhenNullish(z.string(), ''),
  commerce_hub_api_key: defaultWhenNullish(z.string(), ''),
  commerce_hub_access_token: defaultWhenNullish(z.string(), ''),
  commerce_hub_public_key: defaultWhenNullish(z.string(), ''),
  commerce_hub_key_id: defaultWhenNullish(z.string(), ''),
  commerce_hub_terminal_id: defaultWhenNullish(z.string(), ''),
  commerce_hub_client_request_id: defaultWhenNullish(z.string(), '')
});
export type CommerceHubCredentialsResponse = z.infer<
  typeof CommerceHubCredentialsResponse
>;

const fetchPaymentCredentials = async (paymentProvider: string) => {
  const endpoint = buildBentoboxApiEndpoint(
    BENTOBOX_PAYMENT_CREDENTIALS_ENDPOINT
  );
  const response = await restClient.get(endpoint);

  let ResponseObject;

  switch (paymentProvider) {
    case PaymentProviders.COMMERCE_HUB:
      ResponseObject = CommerceHubCredentialsResponse;
      break;

    default:
      ResponseObject = z.object({});
  }

  try {
    return ResponseObject.parse(response);
  } catch (err) {
    console.error('fetchPaymentCredentials: ', err);
    throw err;
  }
};

export const getPaymentCredentials = (paymentProvider: string) => {
  return {
    queryKey: ['paymentCredentials'],
    queryFn: () => fetchPaymentCredentials(paymentProvider),
    retry: false,
    enabled: false
  };
};
